export default __webpack_public_path__ + "358d5ee4dd1b4dfd280ee6c6e8b5470f.svg";